import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Button } from "./ui/button";
import { Lock, RotateCcw, ShieldCheck } from "lucide-react";
import { useSession } from "../lib/session";
import { lockApp } from "../lib/access";
import { toast } from "sonner";
import { AlgorithmLibrary } from "./AlgorithmLibrary";

const STEPS = ["History", "Focused Hx", "Vitals & Triage", "Examination", "Refined DDx", "Investigations", "Final Dx & Rx", "Report"];

export const Header = () => {
  const { state, set, reset } = useSession();
  return (
    <header className="sticky top-0 z-30 bg-card border-b">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center gap-4">
        <img src="/logo192.png" alt="CritiCalc AI" className="w-9 h-9 rounded-md" data-testid="app-logo" />
        <div className="leading-tight">
          <div className="font-heading font-semibold text-lg" data-testid="app-name">CritiCalc AI</div>
          <div className="text-[11px] text-muted-foreground hidden sm:flex items-center gap-1"><ShieldCheck className="w-3 h-3" />No patient data stored</div>
        </div>
        <div className="ml-auto flex items-center gap-2">
          <AlgorithmLibrary />
          <Select value={state.model} onValueChange={(v) => { set("model", v); toast.success("AI model changed"); }}>
            <SelectTrigger className="w-[190px] h-9" data-testid="model-selector"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="gemini" data-testid="model-gemini">Gemini 3 Flash · fast</SelectItem>
              <SelectItem value="claude" data-testid="model-claude">Claude Sonnet 4.5 · deep</SelectItem>
              <SelectItem value="gpt" data-testid="model-gpt">GPT-5.2</SelectItem>
            </SelectContent>
          </Select>
          <Button variant="outline" size="sm" className="h-9" data-testid="btn-reset-session"
            onClick={() => { if (window.confirm("Clear this patient session?")) { reset(); toast("Session cleared"); } }}>
            <RotateCcw className="w-4 h-4 sm:mr-1" /><span className="hidden sm:inline">New patient</span>
          </Button>
          <Button variant="ghost" size="sm" className="h-9" data-testid="btn-lock-device" title="Lock this device"
            onClick={() => { if (window.confirm("Lock this device? The access code will be needed again.")) lockApp(); }}>
            <Lock className="w-4 h-4" />
          </Button>
        </div>
      </div>
      <nav className="max-w-6xl mx-auto px-4 sm:px-6 flex overflow-x-auto" data-testid="stepper">
        {STEPS.map((s, i) => (
          <button key={s} data-testid={`stepper-step-${i}`}
            onClick={() => set("step", i)}
            className={`cc-step ${i === state.step ? "is-active" : ""} ${i < state.step ? "is-done" : ""}`}>
            <span className="font-mono text-xs">{i + 1}</span>{s}
          </button>
        ))}
      </nav>
    </header>
  );
};
